var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"error-page"},[(!_vm.$fetchState.pending)?[(_vm.page)?_c('blocks-list',{attrs:{"blocks":_vm.page.blocks}}):_c('h1',{staticClass:"style-h1"},[_vm._v(_vm._s(_vm.message))])]:_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }